import { Pagination, Autoplay } from "swiper/modules";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleArrowRight } from "@fortawesome/free-solid-svg-icons";

import "swiper/css";
import "swiper/css/pagination";

import "./Home_Banner.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { useNavigate } from "react-router-dom";
import { Context } from "../../utils/context";
import { useContext, useEffect, useState } from "react";

function Home_Banner() {
  const bannerSlides = [
    {
      image: "/assets/images/holidays/home_banner.png",
      title: "DUBAI",
      subtitle: "Discover Dubai Where Dreams Touch the Sky",
    },
    {
      image: "/assets/images/holidays/home_banner.png",
      title: "DUBAI",
      subtitle: "Discover Dubai Where Dreams Touch the Sky",
    },
    {
      image: "/assets/images/holidays/home_banner.png",
      title: "DUBAI",
      subtitle: "Discover Dubai Where Dreams Touch the Sky",
    },
    {
      image: "/assets/images/holidays/home_banner.png",
      title: "DUBAI",
      subtitle: "Discover Dubai Where Dreams Touch the Sky",
    },
  ];

  const navigate = useNavigate();

  const [data, setData] = useState([]);

  const { getData, IMG_URL } = useContext(Context);

  const getDataAll = async () => {
    const response = await getData("/master/banner/");

    setData(response?.data);
  };

  useEffect(() => {
    getDataAll();
  }, []);

  return (
    <section className="home_banner">
      <Swiper
        modules={[Pagination, Autoplay]}
        loop={true}
        speed={900}
        // autoplay={{
        //   delay: 3000,
        //   disableOnInteraction: false,
        // }}
        pagination={{
          clickable: true,
        }}
      >
        {data?.map((slide, index) => (
          <SwiperSlide key={index}>
            <div className="banner_wrapper">
              <img
                src={slide?.image}
                alt={`banner-${index}`}
                className="banner_img"
              />

              <div className="banner_content">
                <h1 className="banner_title">{slide?.name?.name}</h1>

                <p className="banner_subtitle">{slide?.tagline}</p>

                <button
                  class="explore_btn"
                  onClick={() => {
                    navigate(`/location/${slide?.name?.id}/`);
                  }}
                >
                  Explore {slide?.name?.name}
                  <span class="btn_icon">
                    <i class="fa-solid fa-arrow-right"></i>
                  </span>
                </button>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}

export default Home_Banner;
